// Library Methods
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";
import { useSnackbarContext } from "src/contexts/alerts/SnackbarContext";

// Types and API
import { ClinicType } from "../types";
import { updateClinic } from "../api";

export const useUpdateClinic = () => {
  const queryClient = useQueryClient();
  const { getToken } = useTokenAccess();
  const { t } = useTranslation();
  const { setSnackbarInfo } = useSnackbarContext();

  return useMutation({
    mutationFn: async (clinicData: ClinicType) => {
      try {
        const token = await getToken();
        return updateClinic(token, clinicData?.id, clinicData);
      } catch (error) {
        throw error;
      }
    },
    // Invalidate clinics query cache
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["clinics"] });
      setSnackbarInfo({
        variant: "success",
        message: t("Settings updated successfully!"),
      });
    },
    onError: () => {
      setSnackbarInfo({
        variant: "error",
        message: t("Settings could not be updated!"),
      });
    },
  });
};
